import React, { HTMLAttributes, FC } from "react";
import { Skeleton } from "@onmo/ui";
import clsx from "classnames";
import { useStyles } from "./ContinuePlayLoading.style";

interface IContinuePlayLoadingProps {
  isTopGame?: boolean;
}

export const ContinuePlayLoading: FC<
  IContinuePlayLoadingProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const classes = useStyles();
  const { isTopGame, ...otherProps } = props;

  return (
    <div {...otherProps}>
      <Skeleton
        variant="text"
        height={25}
        width={150}
        className={clsx(classes.title, isTopGame && "topGame")}
      />
      <div className={classes.content}>
        {Array.from(new Array(6)).map((_, idx) => (
          <Skeleton
            variant="rect"
            height={168}
            width={104}
            key={idx}
            className={classes.gameImg}
          />
        ))}
      </div>
    </div>
  );
};
